<template>
  <HScaffold title="网络与设备">
    <template #customRight>
      <div @click="clickDebugBtn" style="width:60px;background-color: white; height:100%;"/>
    </template>
    <HCellGroup :data="cellGroupData"/>
    <HCellGroup :data="cellGroupData2"/>
    <HCellGroup :data="cellGroupData3"/>
    <HCellGroup :data="cellGroupData4"/>
    <HCellGroup :data="cellGroupData5"/>
  </HScaffold>
</template>


<script setup>

  import HScaffold from "@/components/utils/HScaffold.vue";
  import HCellGroup from "@/components/utils/HCellGroup.vue";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {hr} from "@/components/utils/HRouter.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {hsp} from "@/components/utils/HSp.js";
  import {showToast} from "vant";

  let useHttp = useHHttp();

  import axios from "axios";
  import {hcf} from "@/components/utils/HComFunctions.js";

  let useUser = useUserStore();

  const ispAndAddress = ref({});
  const cellGroupData = ref([]);
  const cellGroupData2 = ref([]);

  let speedTimer = null;

  const speed = ref(-1);


  const cellGroupData3 = ref([
    {
      "icon": "",
      "title": "账号ID",
      "rightText": useUser.isLogin
          ? useUser.userId
          : "未登录",
      "callBack": useUser.isLogin
          ? null
          : () => {
            hr.go("login");
          }
    },
  ]);
  const cellGroupData4 = ref([
    {
      "icon": "",
      "title": "APP版本",
      "rightText": hdi.appVersion + " - " + hdi.platTypeNo + " - " + hdi.platTypeNo + (hdi.h2d ? "1" : "0"),
    },
  ]);
  const cellGroupData5 = ref([
    {
      "icon": "",
      "title": "设备信息",
      "rightText": hdi.deviceModal,
    },
  ]);

  function updateCellData2() {
    cellGroupData2.value = [
      {
        "icon": "",
        "title": "运营商",
        "rightText": ("Isp" in ispAndAddress.value)
            ? ispAndAddress.value["Isp"]
            : "获取中...",
      },
      {
        "icon": "",
        "title": "国家城市",
        "rightText": ("Country" in ispAndAddress.value) || ("Region" in ispAndAddress.value)
            ? (ispAndAddress.value["Country"] + "-" + ispAndAddress.value["Region"])
            : "获取中...",
      },
      {
        "icon": "",
        "title": "IP",
        "rightText": ispAndAddress.value["Ip"] ?? "获取中...",
      },
    ];
  }

  let debugPressCounter = 0;
  let lastDebugPressMs = 0;

  function clickDebugBtn() {
    const nowMs = Date.now();
    if (nowMs - lastDebugPressMs > 2000) {
      debugPressCounter = 0; // 间隔>2s 视为新一轮，重置计数，防止分散误触(RB-09 时间窗)
    }
    lastDebugPressMs = nowMs;
    debugPressCounter++;
    if (debugPressCounter >= 10) {
      debugPressCounter = 0;
      changeTestServer();
    }
  }

  function changeTestServer() {
    useUser.removeUserInfo();
    hdi.channelFlag = HNewGameUIConfig.newGameUIType === 0 ? "devv" : hdi.channelFlag;
    let devStr = hsp.getString("DEV_DEBUG");
    if (devStr != null) {
      hsp.remove("DEV_DEBUG");
      if(hdi.isRunDesktop){
        showToast('切换至线上版本,请关闭APP,重新打开');
      }else{
        showToast('切换至线上版本,请手动刷新页面');
      }
    } else {
      hsp.setMap(
          "DEV_DEBUG",
          {
            "ApiGw": 'https://api.testylhg24.online',
            "AliasApiGw": "测试线路"
          });
      if(hdi.isRunDesktop){
        showToast('切换至Debug版本,请关闭APP,重新打开');
      }else{
        showToast('切换至Debug版本,请手动刷新页面');
      }
    }
  }

  async function testSpeed() {
    let start = Math.floor(Date.now());
    try {
      await axios.get(useHttp.getServerUrlsConfig().ApiGw + "/api-speed");
    } catch (e) {
    }
    let end = Math.floor(Date.now());
    speed.value = end - start;
    updateCellData();
  }


  function getSpeedColor() {
    if (speed.value === -2) {
      return "#f44336";
    } else if (speed.value === -1) {
      return hcf.getMainFontColor();
    } else if (speed.value <= 500) {
      return "#4CAF50";
    } else if (speed.value <= 1000) {
      return "#888800";
    } else {
      return "#D36914";
    }
  }

  function updateCellData() {
    cellGroupData.value = [
      {
        "icon": "",
        "title": useHttp.getServerUrlsConfig().AliasApiGw,
        "rightText": speed.value === -2
            ? "超时"
            : speed.value === -1
                ? "测速中..."
                : speed.value + "ms",
        "rightTextColor": getSpeedColor(),
      }
    ];
  }


  onMounted(() => {
    testSpeed();
    speedTimer = setInterval(() => {
      testSpeed();
    }, 3000);
    updateCellData();
    updateCellData2();
    useHttp.request("/qp/app/status", (data) => {
      ispAndAddress.value = data;
      updateCellData2();
    }, {isShowLoading: false});
  });

  onUnmounted(() => {
    if (speedTimer) {
      clearInterval(speedTimer);
      speedTimer = null;
    }
  });

</script>


<style scoped>
</style>
